import React from "react";
import { Layers } from "lucide-react";
import { hasPermission } from "../../../utils/permissionUtils";

/**
 * @param {object} branch — bản ghi chi nhánh đầy đủ
 * @param {function} onOpenDepartments — mở modal quản lý bộ phận theo chi nhánh
 */
const RowActions = ({ branch, onOpenDepartments }) => {
  const canManageDepartments = hasPermission("hrm.branches", "R");

  return (
    <div className="flex justify-center gap-1">
      {canManageDepartments && (
        <button
          type="button"
          onClick={() => onOpenDepartments?.(branch)}
          className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-red-600 hover:bg-red-50 border border-transparent hover:border-red-100 transition-colors"
          title="Quản lý bộ phận theo chi nhánh"
          aria-label="Quản lý bộ phận theo chi nhánh"
        >
          <Layers size={18} strokeWidth={2.25} />
        </button>
      )}
    </div>
  );
};

export default RowActions;
